import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { HubSettingsEntryButtonAppearance } from './HubSettingsEntryButtonAppearance.ts';

export const HubSettingsEntryButton: LoadableType<{
	appearance?: HubSettingsEntryButtonAppearance;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HubSettingsEntryButton" */ '../src/hub-settings/HubSettingsEntryButton.tsx'
			)
		).HubSettingsEntryButton,
});
